<div class="scroll">
  <div class="title-wrapper">
    <div class="title">{{ this.report?.Name }}</div>
    <div>
      @if (this.report?.Details != '') {
      <mat-icon class="help-icon" (mouseenter)="showHelp = true" (mouseleave)="showHelp = false"
        (click)="lockHelp = !lockHelp" matTooltip="Click to lock" matTooltipPosition="right" matTooltipShowDelay="1000">
        help
      </mat-icon>
      } @if (showHelp || lockHelp) {
      <div class="help-window">
        <div class="title">Help Info:</div>
        <br />
        <p class="help-info">{{ this.report?.Details }}</p>
      </div>
      }
    </div>
  </div>
  <!-- TOTAL DEVICE USAGE REPORT -->
  @if (paramId == 1) {
  <div>
    <app-device-usage-report></app-device-usage-report>
  </div>
  }

  <!-- INVENTORY REPORT -->
  @if (paramId == 5 || paramId == 7) {
  <div>
    <app-inventory-report></app-inventory-report>
  </div>
  }

  <!-- SIM USAGE REPORT -->
  @if (paramId == 3) {
  <div>
    <app-sim-usage-report></app-sim-usage-report>
  </div>
  }

  <!-- DEVICE USAGE BY INTERVAL REPORT -->
  @if (paramId == 8) {
  <div>
    <app-device-usage-interval-report></app-device-usage-interval-report>
  </div>
  } @if (paramId == 9) {
  <div>
    <app-keep-alive-activity-report></app-keep-alive-activity-report>
  </div>
  } @if (paramId == 10) {
  <div>
    <app-device-usage-apn-report></app-device-usage-apn-report>
  </div>
  } @if (paramId == 11) {
  <div>
    <app-keep-alive-event-report></app-keep-alive-event-report>
  </div>
  } @if (paramId == 12) {
  <div>
    <app-keep-alive-device-state-report></app-keep-alive-device-state-report>
  </div>
  } @if (paramId == 13) {
  <div>
    <app-relay-raw-report></app-relay-raw-report>
  </div>
  } @if (paramId == 14) {
  <div>
    <app-relay-ip-report></app-relay-ip-report>
  </div>
  } @if (paramId == 15) {
  <div>
    <app-relay-apn-report></app-relay-apn-report>
  </div>
  } @if (paramId == 16) {
  <div>
    <app-relay-billing-report></app-relay-billing-report>
  </div>
  }

  @if (paramId == 17) {
  <div>
    <app-keep-alive-tls-raw-report></app-keep-alive-tls-raw-report>
  </div>
  }

  @if (paramId == 18) {
  <div>
    <app-keep-alive-tls-device-report></app-keep-alive-tls-device-report>
  </div>
  }

  @if (paramId == 19) {
  <div>
    <huge-monorepo-radius-sim-report></huge-monorepo-radius-sim-report>
  </div>
  }

  @if (paramId == 20) {
  <div>
    <app-capped-devices-report></app-capped-devices-report>
  </div>
  }

  @if (paramId == 21) {
  <div>
    <app-audit-capping-report></app-audit-capping-report>
  </div>
  }

  @if (paramId == 22) {
  <div>
    <huge-monorepo-sim-latest-location-report></huge-monorepo-sim-latest-location-report>
  </div>
  }

  @if (paramId == 23) {
  <div>
    <huge-monorepo-imei-report></huge-monorepo-imei-report>
  </div>
  }

  <!-- Reports not set up -->
  @if (paramId && [2, 6].includes(paramId)) {
  <div> This report has not been set up. Contact an administrator. </div>
  }
</div>